import React from 'react'
import * as Sentry from '@sentry/react'

import { Error } from './Error'

export const ErrorBoundary: React.FC = ({ children }) => (
  <Sentry.ErrorBoundary
    showDialog
    fallback={<Error />}
    onError={exception => {
      window.appInsights && window.appInsights.trackException({ exception })
      console.error('APP exception', exception)
    }}
  >
    {children}
  </Sentry.ErrorBoundary>
)
